module.exports = __webpack_public_path__ + "img/gd.9661738c.png";